import React from 'react'
import {
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";

function SuccessModal({ show, onHide, title }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered>
      <div
        style={{
          width: "fullscreen",
          height: "240px",
        }}
      >
        <Modal.Body
          style={{
            textAlign: "center",
          }}
        >
          <div style={{ marginTop: "31px" }}>
            <FontAwesomeIcon
              icon={faCheckCircle}
              style={{ width: "109px", height: "109px", color: "#28A138" }}
            />
          </div>
          <div
            style={{
              fontSize: "32px",
              paddingTop: "16px",
              color: "#000000",
            }}
          >
            {title}
          </div>
        </Modal.Body>
      </div>
    </Modal>
  )
}

export default SuccessModal